export default {"src":"/_next/static/media/appleStore.ee3e6c4b.svg","height":23,"width":18,"blurWidth":0,"blurHeight":0};